import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const SeoContext = createContext(null);

export const SeoProvider = ({ children }) => {
  const [pages, setPages] = useState([]);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/seo/pages");
      setPages(data);
    } catch {
      setPages([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);
  const profiles = useMemo(() => Object.fromEntries(pages.map((page) => [page.page_key, page])), [pages]);

  return <SeoContext.Provider value={{ pages, profiles, loading, refresh }}>{children}</SeoContext.Provider>;
};

export const useSeoProfiles = () => useContext(SeoContext) || { pages: [], profiles: {}, loading: false, refresh: async () => {} };